import React, { useContext } from 'react'

import { SelectionContext} from '../../store/selection-context-provider'
import InputCheckbox from '../../utils/controls/input-checkbox'

const CustomerDashboardDueOutsTableHead = () => {
  const selection = useContext(SelectionContext)

  return (
    <thead>
      <tr>
        <th>
          <InputCheckbox
            formClassName='form-horizontal font-0'
            inputProps={{
              checked: selection.allCheckboxIsChecked,
              id: 'all',
              label: 'All',
              name: 'Input Check',
              type: 'checkbox',
            }}
            onChange={selection.handleAllCheckboxChange}
          />
        </th>
        <th aria-label='ID' tabIndex={0}>
          ID
        </th>
        <th aria-label='Section' tabIndex={0}>
          Section
        </th>
        <th aria-label='Category' tabIndex={0}>
          Category
        </th>
        <th aria-label='Customer Name' tabIndex={0}>
          Customer Name
        </th>
        <th aria-label='Due Date' tabIndex={0}>
          Due Date
        </th>
        <th aria-label='Created By' tabIndex={0}>
          Created By
        </th>
        <th aria-label='Date Created' tabIndex={0}>
          Date Created
        </th>
        <th aria-label='Status' tabIndex={0}>
          Status
        </th>
      </tr>
    </thead>
  )
}

export default CustomerDashboardDueOutsTableHead